export const NO_REFRESH_TOKEN_MSG = '리프레시 토큰이 유효하지 않습니다.'
export const NO_REFRESH_TOKEN_CD = 'NO_REFRESH_TOKEN'
export const SUCCESS_CD = 'SUCCESS'
